export const ServiceClientMappingRoute = {
  SERVICECLIENTMAPPINGS: 'serviceclientmappings',
};

export const ServiceClientMappingPathName = {
  SERVICECLIENTMAPPINGS: 'serviceclientmappings',
  SERVICECLIENTMAPPINGFORM_NEW: 'serviceclientmappingform:new',
  SERVICECLIENTMAPPINGFORM: 'serviceclientmappingform',
};

export const TruncateValue = {
  NONE: 'none',
};
